module.exports = __webpack_public_path__ + "media/images/country_flags/cx-6f3bb50b51efe2a11609c7034cd7e5a2.png";